import React from 'react';
import Icon from './Icon';

const SplitIcon = (props) => (
    <Icon {...props}>
        <path d="M9 18.5L17 3M9 18.5C9 19.8807 7.88071 21 6.5 21C5.11929 21 4 19.8807 4 18.5C4 17.1193 5.11929 16 6.5 16C7.88071 16 9 17.1193 9 18.5ZM15 18.5L7 3M15 18.5C15 19.8807 16.1193 21 17.5 21C18.8807 21 20 19.8807 20 18.5C20 17.1193 18.8807 16 17.5 16C16.1193 16 15 17.1193 15 18.5Z" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default SplitIcon;